import { useState, useEffect, useContext } from "react";
import * as Icon from "react-bootstrap-icons";
import PageSection from "../Layout/PageSection";
import { API_URL, PAGINATION_LIST } from "../../data/constants";
import axios from "axios";
import Context from "../../../context";
import dayjs from "dayjs";
import Pagination from "../Layout/Pagination";

function PaymentItem({ payment }) {
  return (
    <div className="payment-hist-item">
      <div className="payment-hist-item-wrapper">
        <div className="payment-hist-info">
          <div>
            <small>Received Date</small>
            <p className="font-weight-bold">
              {dayjs(payment.createdOn).format("MM/DD/YYYY")}
            </p>
          </div>
          <div>
            <small>Statement Number(s)</small>
            <p className="font-weight-bold">#{payment.invoiceNumbers}</p>
          </div>
        </div>
        <div className="payment-hist-amount">
          <h4>${payment?.totalAmount.toFixed(2).toLocaleString()}</h4>
          {/*<p
            className="statement-item-download"
            onClick={() => {
              axios
                .post(
                  API_URL + "/Statements/GetPDF",
                  {
                    invoiceNumber: payment.invoiceNumber,
                    statementId: payment.id,
                  },
                  {
                    headers: {
                      Authorization: localStorage.getItem("accessToken"),
                    },
                  }
                )
                .then((res) => {
                  const base64 = res.data.pdf.split(",")[1];
                  const bytes = window
                    .atob(base64)
                    .split("")
                    .map((c) => c.charCodeAt(0));
                  const file = new Blob([new Uint8Array(bytes)], {
                    type: "application/pdf",
                  });
                  const fileURL = URL.createObjectURL(file);
                  const pdfWindow = window.open();
                  pdfWindow.location.href = fileURL;
                })
                .catch((error) => {
                  console.error(error);
                });
            }}>
            Download PDF &nbsp;
            <Icon.FilePdf height={24} width={24} />
          </p>*/}
        </div>
      </div>
    </div>
  );
}

function PaymentHistoryList({
  currentPayments,
  currentPage,
  perPage,
  numItems,
  paginate,
  setPerPage,
}) {
  return (
    <PageSection>
      <ul className="payment-hist-item-list">
        {currentPayments.map((payment, key) => {
          return <PaymentItem payment={payment} key={key} />;
        })}
      </ul>
      <div className="col"></div>
      <div className="pagination-container row">
        <Pagination
          currentPage={currentPage}
          perPage={perPage}
          numItems={numItems}
          paginate={paginate}
        />
        <div className="col-sm">
          <div className="form-section">
            <div className="form-group">
              <label className="form-label"></label>
              <select
                className="form-control dropdown"
                placeholder="Select"
                onChange={(e) => setPerPage(e.target.value)}>
                {PAGINATION_LIST.map((value, index) => {
                  return (
                    <option value={value.value} key={index}>
                      {value.text}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  );
}

export default function PaymentHistoryPage() {
  const { contextState, setContextState } = useContext(Context);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [numItems, setNumItems] = useState(0);
  const [currentPayments, setCurrentPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const account = contextState.currentAccount;
    let userRole = localStorage.getItem("userRole");

  useEffect(() => {
    setIsLoading(true);
    axios
      .post(
        API_URL + "/Payments/History",
        {
          pageNumber: currentPage,
          pageSize: perPage,
          customerId: account?.contract?.customerId,
          customerNumber: account?.customerNumber,
          masterCustomerId: null,
          userName: null,
          userRole: userRole
        },
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      )
      .then((res) => {
        setNumItems(res?.data?.recordCount);
        if(res?.data?.payments.length > 0){
           setCurrentPayments(
               res?.data?.payments
           );   
        }
          setIsLoading(false);
      })
      .catch((err) => console.error(err));
  }, [perPage, currentPage]);

  function paginate(num) {
    setCurrentPage(num);
  }
  return (
    <div className="individual-wrapper">
      <div className="individual-header">
        <h1>Payment History</h1>
      </div>
        {isLoading ? (
            <div className="d-flex justify-content-center align-items-center">
                <div className="spinner-border mr-4" role="status"></div>
                <h4>Loading Payment History...</h4>
            </div>
        ) : (
      <PaymentHistoryList
        perPage={perPage}
        setPerPage={setPerPage}
        currentPage={currentPage}
        numItems={numItems}
        currentPayments={currentPayments}
        paginate={paginate}
      />
        )}
    </div>
  );
}
